const details = () => {
    document.querySelectorAll('.details__item').forEach(item => {
        item.addEventListener('click', () => {
            const svgUseElement = item.querySelector('.details__summary-svg svg use');
            if (item.open) {
                svgUseElement.setAttribute("xlink:href", "img/sprite.svg#arrow-down");
            } else {
                svgUseElement.setAttribute("xlink:href", "img/sprite.svg#arrow-up");
            }
        });
    });
};

export default details;
